import React, { Component } from "react";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";

import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
// import {
//   ReusableOnboardingLink,
//   ReusableOnboardingButton,
// } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import isEmpty from "../../../../store/validation/is-Empty";

import { HealthAndSenitationScreenTwo } from "./InsideScreenHealth/HealthAndSenitationScreenTwo";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import Media from "react-media";

export class VendorHealthAndSenitationFacilityEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editButton: false,
      actionButton: false,
      loader: false,
      hasSetMapProps: false,
      healthAndSanitizeFacilityCheck: true,
      healthandsanitization_facility: [],
      // DATA
      selected_health_and_sanitization_facility: [],
      primary_health_and_sanitization_facility: {},
      errors: [],
    };
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.health_inside_facility) &&
      !nextState.hasSetMapProps
    ) {
      let selected_health_and_sanitization_facility =
        nextProps.onboarding.selected_health_and_sanitization_facility;
      let primary_health_and_sanitization_facility =
        nextProps.onboarding.primary_health_and_sanitization_facility;

      if (
        !isEmpty(
          nextProps.onboarding.primary_health_and_sanitization_facility
        ) &&
        !isEmpty(selected_health_and_sanitization_facility[0])
      ) {
        if (
          !isEmpty(
            nextProps.onboarding.primary_health_and_sanitization_facility
          ) &&
          isEmpty(selected_health_and_sanitization_facility[0]._id) &&
          selected_health_and_sanitization_facility.length > 0 &&
          isEmpty(primary_health_and_sanitization_facility._id)
        ) {
          selected_health_and_sanitization_facility =
            nextProps.health_inside_facility.filter((data) =>
              selected_health_and_sanitization_facility.includes(data._id)
            );
          primary_health_and_sanitization_facility =
            nextProps.health_inside_facility.filter(
              (data) => data._id === primary_health_and_sanitization_facility
            )[0];
        }
      }
      let all_healthandsanitization_facility =
        nextProps.health_inside_facility.filter(
          (point) =>
            !selected_health_and_sanitization_facility.some(
              (selected) => selected._id === point._id
            )
        );

      return {
        selected_health_and_sanitization_facility: !isEmpty(
          selected_health_and_sanitization_facility
        )
          ? selected_health_and_sanitization_facility
          : [],
        primary_health_and_sanitization_facility: !isEmpty(
          primary_health_and_sanitization_facility
        )
          ? primary_health_and_sanitization_facility
          : {},
        healthandsanitization_facility: all_healthandsanitization_facility,
        hasSetMapProps: true,
        healthAndSanitizeFacilityCheck: !isEmpty(
          nextProps.onboarding.healthAndSanitizeFacilityCheck
        )
          ? nextProps.onboarding.healthAndSanitizeFacilityCheck
          : true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /********************************
   * @DESC Inside Facility Handler
   ********************************/
  onInsideFacilityBackButton = (e) => {
    this.props.history.push("/profile");
  };

  whithOutInsideFacilityNextButton = (e) => {
    this.setState({
      actionButton: false,
    });
    this.props.history.push("/profile");
  };

  editClick = (e) => {
    this.setState({
      editButton: !this.state.editButton,
    });
  };

  onInsideFacilityNextButton = (e) => {
    let formData = {
      healthAndSanitizeFacilityCheck: this.state.healthAndSanitizeFacilityCheck,
      selected_health_and_sanitization_facility:
        this.state.selected_health_and_sanitization_facility,
      primary_health_and_sanitization_facility:
        this.state.primary_health_and_sanitization_facility,
      id: this.props.onboarding._id,
      vendor_id: this.props.onboarding.vendor_id,
    };
    console.log(formData);
    this.props.create_and_update_restaurant(formData);
    this.setState({
      actionButton: false,
    });

    // let formData = {
    //   selected_health_and_sanitization_facility:
    //     this.state.selected_health_and_sanitization_facility,
    //   primary_health_and_sanitization_facility:
    //     this.state.primary_health_and_sanitization_facility,
    //   healthAndSanitizeFacilityCheck:
    //     this.state.healthAndSanitizeFacilityCheck,
    //   id: this.props.onboarding._id,
    //   vendor_id: this.props.auth.user.VendorUser._id,
    // };
    // this.props.create_and_update_restaurant(formData);
    // this.setState({
    //   actionButton: false,
    //   // editButton: false,
    // });
  };

  othersHealthAndSafetyHandlerTwo = (icon, index) => (e) => {
    let buttonArray = this.state.healthandsanitization_facility;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_health_and_sanitization_facility;
    let primaryIcon = this.state.primary_health_and_sanitization_facility;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_health_and_sanitization_facility: Restaurant,
        primary_health_and_sanitization_facility: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_health_and_sanitization_facility: Restaurant,
      actionButton: true,
    });
  };

  othersHealthAndSafetyPrimarySelectorTwo = (icon) => (e) => {
    this.setState({
      primary_health_and_sanitization_facility: icon,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Remove Primary button handler
   ****************************************/
  othersHealthAndSafetyRemoveButtonTwo = (icon) => (e) => {
    let {
      healthandsanitization_facility,
      selected_health_and_sanitization_facility,
      primary_health_and_sanitization_facility,
    } = this.state;

    let iconIndexAtAllIcons = healthandsanitization_facility.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons =
      selected_health_and_sanitization_facility.findIndex(
        (icons) => icons._id === icon._id
      );
    let iconAtPrimaryIcon =
      !isEmpty(primary_health_and_sanitization_facility) &&
      primary_health_and_sanitization_facility._id === icon._id
        ? true
        : false;
    if (selected_health_and_sanitization_facility.length === 0) {
      selected_health_and_sanitization_facility.push(icon);
      healthandsanitization_facility.splice(iconIndexAtAllIcons, 1);
      primary_health_and_sanitization_facility = icon;
    } else if (iconAtPrimaryIcon) {
      selected_health_and_sanitization_facility.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_facility.push(icon);
      if (selected_health_and_sanitization_facility.length === 1) {
        primary_health_and_sanitization_facility =
          selected_health_and_sanitization_facility[0];
      } else {
        primary_health_and_sanitization_facility = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_health_and_sanitization_facility.splice(
        iconIndexAtSelectedIcons,
        1
      );
      healthandsanitization_facility.push(icon);
      if (selected_health_and_sanitization_facility.length === 1) {
        primary_health_and_sanitization_facility =
          selected_health_and_sanitization_facility[0];
      }
    } else {
      selected_health_and_sanitization_facility.push(icon);
      healthandsanitization_facility.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_health_and_sanitization_facility:
        selected_health_and_sanitization_facility,
      healthandsanitization_facility: healthandsanitization_facility,
      primary_health_and_sanitization_facility:
        primary_health_and_sanitization_facility,
      actionButton: true,
    });
  };

  facilityCheckSwitchValue = (e) => {
    this.setState({
      healthAndSanitizeFacilityCheck:
        !this.state.healthAndSanitizeFacilityCheck,
      actionButton: true,
    });
    // this.setState({
    //   selected_health_and_sanitization_facility: [],
    //   primary_health_and_sanitization_facility: {},
    // });
  };

  renderHealthsenitationFields = () => {
    const { editButton, actionButton, healthAndSanitizeFacilityCheck } =
      this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div>
            <HealthAndSenitationScreenTwo
              facilityCheck={healthAndSanitizeFacilityCheck}
              facilityCheckHandler={this.facilityCheckSwitchValue}
              bigText="Following are available Inside the Facility"
              smallText="Please select items from the list below"
              primaryBigText="Out of the features selected above, which one is primary?"
              primarySmallText="( Select one primary feature accepted at your facility)"
              otherHealth={this.state.healthandsanitization_facility}
              selectedOtherHealth={
                this.state.selected_health_and_sanitization_facility
              }
              primaryOtherHealth={
                this.state.primary_health_and_sanitization_facility
              }
              onRestaurantSelectorArraySelector={
                this.othersHealthAndSafetyHandlerTwo
              }
              onRestaurantsPrimarySelector={
                this.othersHealthAndSafetyPrimarySelectorTwo
              }
              removeButton={this.othersHealthAndSafetyRemoveButtonTwo}
              onBackButtonTwoClick={this.onInsideFacilityBackButton}
              onNextButtonTwoClick={
                actionButton === false
                  ? this.whithOutInsideFacilityNextButton
                  : this.onInsideFacilityNextButton
              }
              protocolNext={editButton === true ? true : false}
              actionButton={actionButton}
              extraClass={"col-6"}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/profile"
                displayText="Back"
              />
              <div className="col-12 col-md-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0 mobile-mt-4">
                <div className=" p-0">
                  <div>
                    <TopTextReusableComponent
                      headingText="Health and Sanitation"
                      headingParagraph="( Please enter information about the Hygiene and Sanitation efforts and protocol )"
                      displayEdit={this.state.editButton}
                      onClickEdit={this.editClick}
                    />
                  </div>
                  <Form noValidate onSubmit={this.onInsideFacilityNextButton}>
                    {this.renderHealthsenitationFields()}
                  </Form>
                </div>
              </div>
            </div>

            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

VendorHealthAndSenitationFacilityEdit.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  health_inside_facility: state.category.health_inside_facility,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(VendorHealthAndSenitationFacilityEdit));
